import { createRoutes as createHomeworkRoutes } from './homework/router'
import { createRoutes as createLessonRoutes } from './lesson/router'

export function createRoutes() {
  return [
    ...createHomeworkRoutes(),
    ...createLessonRoutes(),
  ]
}
